import angular from 'angular';

let ServiceDetailController = function ($filter, $mdDialog, $scope, $state, Toast, Service) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.service;

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete
  });

  activate();

  function activate() {
    clearForm();

    loadResource($ctrl.id);
  }

  function clearForm(form) {
    $ctrl.service = {};

    if (form) {
      form.$setPristine(); 
      form.$setUntouched();
    }
  }

  function handleDelete(service, event) {
    let confirmMessage = 'service-detail-delete-confirm-text';

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')(confirmMessage))
      .ariaLabel($filter('translate')(confirmMessage))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Service
          .destroy(service)
          .then(response => {
            Toast.success($filter('translate')('service-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('service.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, service) {
    if (!form.$valid) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    save(service);
  }

  // Local functions
  function loadResource(id){
    if (id) {
      $ctrl.uiState = 'LOADING';

      Service.show(id)
        .then(response => {
          $ctrl.service = response;
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:' ,  err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
    }
  }

  function loadDomainResources() {
    let promises = [];

    promises.push(Module.index());

    return Promise.all(promises);
  }

  function save(service) {
    $ctrl.saving = true;

    Service
      .save(service)
      .then(response => {
        Toast.success($filter('translate')('service-detail-save-success'));
        $ctrl.service = response;
        $ctrl.saving = false;
        $state.go('service.list');
      })
      .catch(err => {
        let defaultErrMsg = 'common-server-error';
        let fourONineMsg = 'service-detail-409-error';
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error($filter('translate')(message));
        console.log('err:' ,  err);
        $ctrl.saving = false;
      });
  }
}

ServiceDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Service'];

export default ServiceDetailController;


// WEBPACK FOOTER //
// ./client/app/components/service/service-detail.controller.js